import { SetPlannedDynamic as DLSetPlannedDynamic, SendWelcomePage as DLSendWelcomePage, ShowWelcomePage as DLShowWelcomePage, StartNoisemeter as DLStartNoisemeter, StopNoisemeter as DLStopNoisemeter, ResetNoisemeter as DLResetNoisemeter, GetNoisemeterStats as DLGetNoisemeterStats, GetActiveZones as DLGetActiveZones, ReportNoiseLevel as DLReportNoiseLevel, GetNoisemeterState as DLGetNoisemeterState } from './../../../DL/Admin/Overlays/NoisemeterV2'

//===== ADMIN =====//

const SetPlannedDynamic = async (id) => {
    try {
        const response = await DLSetPlannedDynamic(id)
        return response
    } catch (error) {
        return { success: false, message: 'Error inesperado en BL (Planned Dynamic).' }
    }
}

const SendWelcomePage = async () => {
    try {
        const response = await DLSendWelcomePage()
        return response
    } catch (error) {
        return { success: false, message: 'Error inesperado en BL (General Welcome).' }
    }
}

const ShowWelcomePage = async () => {
    try {
        const response = await DLShowWelcomePage()
        return response
    } catch (error) {
        return { success: false, message: 'Error inesperado en BL (Welcome V2).' }
    }
}

const StartNoisemeter = async (gameData) => {
    try {
        const response = await DLStartNoisemeter(gameData)
    
        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        return { success: false, message: 'Error inesperado en BL (Start V2).' }
    }
}

const StopNoisemeter = async () => {
    try {
        const response = await DLStopNoisemeter()
        return response
    } catch (error) {
        return { success: false, message: 'Error inesperado en BL (Stop V2).' }
    }
}

const ResetNoisemeter = async () => {
    try {
        const response = await DLResetNoisemeter()
        return response
    } catch (error) {
        return { success: false, message: 'Error inesperado en BL (Reset V2).' }
    }
}

const GetNoisemeterStats = async () => {
    try {
        const response = await DLGetNoisemeterStats()
        return response
    } catch (error) {
        return { success: false, message: 'Error inesperado en BL (Stats V2).' }
    }
}

const GetZonesList = async () => {
    try {
        const response = await DLGetActiveZones()
        
        if (response.success && response.data) {
            if (Array.isArray(response.data)) {
                return { success: true, data: response.data }
            }

            const zonesArray = Object.keys(response.data);
            return { success: true, data: zonesArray }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        return { success: false, message: 'Error obteniendo lista de zonas para V2.' }
    }
}

//===== FAN =====//

const SendNoiseReport = async (matchId, zone, volume) => {
    if (!matchId || !zone || volume < 0) return;

    const payload = {
        matchId: matchId,
        zone: zone,
        volume: parseFloat(volume)
    };

    await DLReportNoiseLevel(payload);
}

//===== SCREEN =====//

const GetScreenState = async () => {
    try {
        const response = await DLGetNoisemeterState()
        
        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        return { success: false, message: 'Error inesperado V2.' }
    }
}

export { SetPlannedDynamic, SendWelcomePage, ShowWelcomePage, StartNoisemeter, StopNoisemeter, ResetNoisemeter, GetNoisemeterStats, GetZonesList, SendNoiseReport, GetScreenState };
